module.exports = ".software-slide-form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .software-slide-form .info {\n    width: calc(100% - 240px);\n    margin-left: 20px; }\n  .software-slide-form .info textarea {\n      height: 80px;\n      resize: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-software-slide-form/product-software-slide-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-software-slide-form/product-software-slide-form.component.scss
// module chunks = main